<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...$$props}
  ><path fill="currentColor" d="M6 4.5h4.5v15H6v-15ZM13.5 4.5H18v15h-4.5v-15Z" /></svg
>
